const GAP = 48;

function getHeaderOffset() {
    const header = document.getElementById('header');

    if (!header) {
        return 0;
    }

    // offsetHeight ignores the translateY used to hide the header, so this is
    // the space it will cover once scrolling up reveals it again.
    const top = parseFloat(window.getComputedStyle(header).top) || 0;

    return top + header.offsetHeight;
}

jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
    const confirmation = document.getElementById('gform_confirmation_wrapper_' + formId)
        || document.getElementById('gform_confirmation_message_' + formId);

    if (!confirmation) {
        return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const targetY = confirmation.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - GAP;

    window.scrollTo({
        top: Math.max(0, targetY),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
});
